import HttpClient from '@/utility/http-client';

export default {
    getList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/voucher/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}`;
        return HttpClient.instance().get(url);
    },
    applyVoucher(dataRequest: any) {
        const url = `/api/voucher/`;
        return HttpClient.instance().post(url, dataRequest);
    }
};
